import useStyles from "../../assets/styles/styles";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Grid,
    Box,
    Typography,
    IconButton,
    List,
    ListItem,
    Divider,
    Switch,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from "@material-ui/core";
import MenuProfile from "../Menu/MenuProfile";
import { useHistory } from "react-router";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CustomCalendarProfileMedical from "../Calendar/CalendarProfileMedical";
import "../AskTurn/SelectDateDrawer/doctorCalendarAgenda.css";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AssignmentIcon from "@material-ui/icons/Assignment";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import Header from "../GenericHeader/Header";


const userCode = parseInt(window.localStorage.getItem("numeroPersona"));

const CalendarMedical = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const modelAgendaMedicalReducer = useSelector(state => state.appointmentsReducer);
    const [modelAgendaMedical, setMedicalAgenda] = useState([]);
    const [schedule, setSchedule] = useState([""]);
    const [selectedMedicalCenter, setSelectedMedicalCenter] = useState(null);
    const [selectedSpecialty, setSelectedSpecialty] = useState(null);
    const [centrosMedicos, setCentrosMedicos] = useState([]);
    const [especialidades, setEspecialidades] = useState([]);
    const [showCalendar, setShowCalendar] = useState(false);
    const [expandedCenter, setExpandedCenter] = useState(true);
    const [expandedSpecialty, setExpandedSpecialty] = useState(false);
    const [switchStateCentros, setSwitchStateCentros] = useState({});
    const [switchStateSpecialty, setSwitchStateSpecialty] = useState({});
    const date = new Date();

    useEffect(() => {
        if (modelAgendaMedicalReducer?.medicalAgenda?.agenda) {
            setMedicalAgenda(modelAgendaMedicalReducer.medicalAgenda.agenda);
        }
    }, [modelAgendaMedicalReducer?.medicalAgenda?.agenda]);


    useEffect(() => {
        const savedFilters = localStorage.getItem('calendarFilters');

        if (savedFilters) {
            const filters = JSON.parse(savedFilters);
            setSwitchStateCentros(filters.switchStateCentros || {});
            setSwitchStateSpecialty(filters.switchStateSpecialty || {});
            setSelectedMedicalCenter(filters.selectedMedicalCenter);
            setEspecialidades(filters.especialidades || []);
            setSelectedSpecialty(filters.selectedSpecialty);
            setShowCalendar(filters.showCalendar || false);
            setExpandedSpecialty(filters.expandedSpecialty || false);

            if (filters.schedule) {
                setSchedule(filters.schedule);
            }
        }
    }, []);

    


    useEffect(() => {
        if (modelAgendaMedical) {
            const definedCenters = {};
            modelAgendaMedical?.forEach(item => {
                if (!definedCenters[item.centroMedico]) {
                    definedCenters[item.centroMedico] = {
                        codigo: item.centroMedico,
                        descripcion: item.centroMedicoDescripcion
                    };
                }
            });

            const singleCenters = Object.values(definedCenters);
            setCentrosMedicos(singleCenters);

            localStorage.setItem('centrosMedicos', JSON.stringify(singleCenters));

            const savedFilters = localStorage.getItem('calendarFilters');
            if (savedFilters) {
                const filters = JSON.parse(savedFilters);
                if (!filters.selectedMedicalCenter && singleCenters.length === 1) {
                    handleMedicalCenterChange(singleCenters[0]);
                }
            } else if (singleCenters.length === 1) {
                handleMedicalCenterChange(singleCenters[0]);
            }
        } else {
            const savedCentros = localStorage.getItem('centrosMedicos');
            if (savedCentros) {
                setCentrosMedicos(JSON.parse(savedCentros));
            }
        }
    }, [modelAgendaMedical]);


    const handleMedicalCenterChange = (centro) => {
        const isActive = !!switchStateCentros[centro.descripcion];

        if (isActive) {
            const newSwitchState = {
                ...switchStateCentros,
                [centro.descripcion]: false
            };
            setSwitchStateCentros(newSwitchState);

            localStorage.setItem('calendarFilters', JSON.stringify({
                switchStateCentros: newSwitchState,
                switchStateSpecialty: {},
                selectedMedicalCenter: null,
                especialidades: [],
                selectedSpecialty: null,
                showCalendar: false,
                expandedSpecialty: false
            }));

            setSelectedMedicalCenter(null);
            setEspecialidades([]);
            setSelectedSpecialty(null);
            setSwitchStateSpecialty({});
            setSchedule([]);
            setShowCalendar(false);
            setExpandedSpecialty(false);
        } else {
            const newSwitchState = {};
            Object.keys(switchStateCentros).forEach(key => {
                newSwitchState[key] = false;
            });
            newSwitchState[centro.descripcion] = true;
            setSwitchStateCentros(newSwitchState);

            setShowCalendar(false);
            setSelectedSpecialty(null);
            setSchedule([]);
            setSwitchStateSpecialty({});
            setSelectedMedicalCenter(centro);
            setExpandedCenter(true);
            setExpandedSpecialty(true);

            if (modelAgendaMedical) {
                const uniqueSpecialties = {};
                modelAgendaMedical
                    .filter(item => item.centroMedico === centro.codigo)
                    .forEach(item => {
                        if (!uniqueSpecialties[item.especialidadCodigo]) {
                            uniqueSpecialties[item.especialidadCodigo] = {
                                codigo: item.especialidadCodigo,
                                descripcion: item.especialidadDescripcion
                            };
                        }
                    });

                const specialtyFilter = Object.values(uniqueSpecialties);
                setEspecialidades(specialtyFilter);

                localStorage.setItem('calendarFilters', JSON.stringify({
                    switchStateCentros: newSwitchState,
                    switchStateSpecialty: {},
                    selectedMedicalCenter: centro,
                    especialidades: specialtyFilter,
                    selectedSpecialty: null,
                    showCalendar: false,
                    expandedSpecialty: true
                }));

                if (specialtyFilter.length === 1) {
                    handleSpecialtyChange(specialtyFilter[0]);
                }
            } else {
                setEspecialidades([]);
                localStorage.setItem('calendarFilters', JSON.stringify({
                    switchStateCentros: newSwitchState,
                    switchStateSpecialty: {},
                    selectedMedicalCenter: centro,
                    especialidades: [],
                    selectedSpecialty: null,
                    showCalendar: false,
                    expandedSpecialty: true
                }));
            }
        }
    };


    const handleSpecialtyChange = (especialidad) => {
        const isActive = !!switchStateSpecialty[especialidad.descripcion];

        if (isActive) {
            const newSpecialtyState = {
                ...switchStateSpecialty,
                [especialidad.descripcion]: false
            };
            setSwitchStateSpecialty(newSpecialtyState);

            const currentFilters = JSON.parse(localStorage.getItem('calendarFilters') || '{}');
            localStorage.setItem('calendarFilters', JSON.stringify({
                ...currentFilters,
                switchStateSpecialty: newSpecialtyState,
                selectedSpecialty: null,
                showCalendar: false
            }));

            setSelectedSpecialty(null);
            setSchedule([]);
            setShowCalendar(false);
        } else {
            const newSpecialtyState = {};
            Object.keys(switchStateSpecialty).forEach(key => {
                newSpecialtyState[key] = false;
            });
            newSpecialtyState[especialidad.descripcion] = true;

            setSwitchStateSpecialty(newSpecialtyState);
            setSelectedSpecialty(especialidad);
            setShowCalendar(true);

            const currentFilters = JSON.parse(localStorage.getItem('calendarFilters') || '{}');
            localStorage.setItem('calendarFilters', JSON.stringify({
                ...currentFilters,
                switchStateSpecialty: newSpecialtyState,
                selectedSpecialty: especialidad,
                showCalendar: true
            }));
        }
    };



    useEffect(() => {
        if (!selectedMedicalCenter || !selectedSpecialty || !modelAgendaMedical) {
            setSchedule([]);
            setShowCalendar(false);
            return;
        }

        const agenda = modelAgendaMedical.filter(element =>
            element.centroMedico === selectedMedicalCenter.codigo &&
            element.especialidadCodigo === selectedSpecialty.codigo
        );

        let filteredAgenda = [];

        if (agenda.length > 0) {
            if (modelAgendaMedical === 'TODOS') {
                filteredAgenda = agenda.filter(element => element?.tipoAtencion === "R");
            } else {
                const regular = agenda.filter(element =>
                    element?.tipoAtencion === "P" || element?.tipoAtencion === "W"
                );

                const available = modelAgendaMedical.filter(x =>
                    x.estadoTurno === 'DISPONIBLE' &&
                    x.centroMedico === selectedMedicalCenter.codigo &&
                    x.especialidadCodigo === selectedSpecialty.codigo
                ) || [];

                filteredAgenda = [...regular, ...available];
            }
        }

        setSchedule(filteredAgenda);
        setShowCalendar(true);
    }, [selectedMedicalCenter, selectedSpecialty, modelAgendaMedical]);



    function iconsAccordion(icon, classes) {
        switch (icon) {
            case 1:
                return <LocationCityIcon className={classes.filterCenterSpecialtyIconRound} />
            case 2:
                return <AssignmentIcon className={classes.filterCenterSpecialtyIconRound} />;
            default:
                break;
        }
    }


    return (
        <>
            <MenuProfile />
            <Box className={classes.txtTitleMedicalAgenda}>
                <Header title="Mi Agenda de Turnos" />
            </Box>
            <Box className={classes.boxHeadermedicalCalendar} >
                <IconButton onClick={() => history.push('/MedicalProfile')}>
                    <ArrowBackIcon className={classes.iconFilter} />
                </IconButton>
            </Box>
            <Box className={classes.contentBox}>
                <Box className={classes.medicalProfileAccordion}>
                    <Accordion
                        expandedCenter
                        onChange={() => setExpandedCenter(!expandedCenter)}
                        style={{ height: "fit-content" }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Grid item xs={1}>
                                {iconsAccordion(1, classes)}
                            </Grid>
                            <Typography className={classes.txtTitleFilterMedical}>
                                Centro Médico
                            </Typography>
                        </AccordionSummary>
                        <Divider />
                        <AccordionDetails>
                            <List
                                component="nav"
                                aria-label="mailbox folders"
                                className={` ${classes.switchiwCentroMedico} ${classes.root}`}
                                sx={{
                                    '& .MuiDivider-fullWidth': {
                                        height: '1px',
                                        margin: '5px',
                                        borderBottomWidth: "0px",
                                    },
                                }}>
                                {centrosMedicos.map((centro) => (
                                    <Fragment key={centro.codigo}>
                                        <ListItem className={classes.listItemTurn} >
                                            <Typography className={classes.medicalCenterFilterDescription}>
                                                {centro.descripcion}
                                            </Typography>
                                            <Switch
                                                name={centro.descripcion}
                                                onChange={() => handleMedicalCenterChange(centro)}
                                                checked={!!switchStateCentros[centro.descripcion]}
                                                classes={{ root: classes.switchColor }}
                                                value={centro.descripcion}>
                                            </Switch>
                                        </ListItem>
                                        <Divider />
                                    </Fragment>
                                ))}
                            </List>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion
                        expanded={expandedSpecialty}
                        onChange={() => setExpandedSpecialty(!expandedSpecialty)}
                        className={`${!selectedMedicalCenter}`}
                        disabled={!selectedMedicalCenter}
                        style={{ height: "fit-content" }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Grid item xs={1}>
                                {iconsAccordion(2, classes)}
                            </Grid>
                            <Typography className={classes.txtTitleFilterMedical}>
                                Especialidad
                            </Typography>
                        </AccordionSummary>
                        <Divider />
                        <AccordionDetails>
                            <List
                                component="nav"
                                aria-label="mailbox folders"
                                className={` ${classes.switchiwCentroMedico} ${classes.root}`}
                                sx={{
                                    '& .MuiDivider-fullWidth': {
                                        height: '1px',
                                        margin: '5px',
                                        borderBottomWidth: "0px",
                                    },
                                }}>
                                {especialidades.map((especialidad) => (
                                    <Fragment key={especialidad.codigo}>
                                        <ListItem className={classes.listItemTurn}>
                                            <Typography className={classes.medicalCenterFilterDescription}>
                                                {especialidad.descripcion}
                                            </Typography>
                                            <Switch
                                                name={especialidad.descripcion}
                                                onChange={() => handleSpecialtyChange(especialidad)}
                                                checked={!!switchStateSpecialty[especialidad.descripcion]}
                                                classes={{ root: classes.switchColor }}
                                                value={especialidad.descripcion}>
                                            </Switch>
                                        </ListItem>
                                        <Divider />
                                    </Fragment>
                                ))}
                            </List>
                        </AccordionDetails>
                    </Accordion>
                </Box>
                {showCalendar && selectedMedicalCenter && selectedSpecialty && (
                    <Box style={{ marginTop: "50px" }}>
                        <Box id="calendarioAgenda" className={`${classes.boxCalendarDetails} ${classes.centeredBox}`}>
                            <Box className={classes.boxCalendarStyle}>
                                <Box className={classes.boxDetailsCalendarStyleCards}>
                                    <Box className={`${classes.boxPointsDrawer_AgendaSusp} ${classes.boxPointsDrawer_Seleccionado} ${classes.box15x15}`} />
                                    <Typography className={`${classes.txtLinksInCard} ${classes.appointmentType}`} >
                                        Seleccionado
                                    </Typography>
                                </Box>
                                <Box className={classes.boxDetailsCalendarStyleCards}>
                                    <Box className={`${classes.boxPointsDrawer_AgendaSusp} ${classes.boxPointsDrawer_Disponible} ${classes.box15x15}`} />
                                    <Typography className={`${classes.txtLinksInCard} ${classes.appointmentType}`} >
                                        Con Turnos
                                    </Typography>
                                </Box>
                                <Box className={classes.boxDetailsCalendarStyleCards}>
                                    <Box className={`${classes.boxPointsDrawer_AgendaSusp} ${classes.boxPointsDrawer_SinTurnoAgenda} ${classes.box15x15}`} />
                                    <Typography className={`${classes.txtLinksInCard} ${classes.noAvailableTurnIndicator} `}>
                                        Sin turno
                                    </Typography>
                                </Box>
                            </Box>
                            <Box className={`${classes.calendarContainer} ${classes.calendarAgendaMedical}`}>
                                <CustomCalendarProfileMedical
                                    agendaMedical={schedule}
                                    centroMedico={selectedMedicalCenter}
                                    especialidad={selectedSpecialty}
                                />
                            </Box>
                        </Box>
                    </Box>
                )}
            </Box>
        </>
    );
};

export default CalendarMedical;